import React, {useState} from "react"
import ObjectID from "bson-objectid"
import {Button, FormControl, FormLabel, Select} from "@chakra-ui/react"

import {FileUpload} from "@components/elements"
import {ILabel} from "@backend/types"

type LabelUploadProps = {
    register: any
    errors?: any
    labels?: PickedLabel[]
    onLabelsChange: (labels: PickedLabel[]) => void
}

export type PickedLabel = Pick<ILabel, "_id" | "indicator" | "questionStart" | "questionEnd" | "moreInfo">

export const labelHeaders: Record<keyof PickedLabel, { title?: string, required?: boolean, hidden?: boolean }> = {
    _id: {
        hidden: true
    },
    indicator: {
        title: "Label Name",
        required: true
    },
    questionStart: {
        title: "Question start, that users will see",
        required: true
    },
    questionEnd: {
        title: "Question end, that users will see",
        required: true
    },
    moreInfo: {
        title: "Label description, that users will see"
    }
}

export default function LabelUpload({labels, onLabelsChange, register, errors}: LabelUploadProps) {
    const [records, setRecords] = useState<{
        fileHeaders?: string[]
        data?: any[]
    } | null>(null)

    const [mappedRecords, setMappedRecords] = useState<{
        mappedHeaders?: Record<keyof PickedLabel, string>
    } | null>(null)

    function onFileUpload(records: any[]) {
        if (!records || !records.length) {
            alert("There is no record on the file")
            return
        }

        const record = records[0]

        setRecords({
            fileHeaders: Object.keys(record),
            data: records
        })

    }

    function onMapClick() {
        if (!mappedRecords || !mappedRecords.mappedHeaders) {
            return
        }
        const {mappedHeaders} = mappedRecords

        //TODO fix this later
        if (!mappedHeaders.indicator || !mappedHeaders.questionStart || !mappedHeaders.questionEnd) {
            return
        }

        const labels: PickedLabel[] = records.data.map(x => ({
            _id: ObjectID().toHexString(),
            indicator: x[mappedHeaders.indicator],
            questionStart: x[mappedHeaders.questionStart],
            questionEnd: x[mappedHeaders.questionEnd],
            moreInfo: mappedHeaders.moreInfo ? x[mappedHeaders.moreInfo] : undefined
        }))

        onLabelsChange(labels)

        setRecords(null)
        setMappedRecords(null)
    }

    if (records)
        return <FormControl isRequired>
            <FormLabel>Map your file headers</FormLabel>
            <div className="divide-y divide-gray-100">
                {Object.keys(labelHeaders).filter(x => !labelHeaders[x].hidden).map((key) =>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <div className="text-sm font-medium leading-6 text-gray-900">
                            {labelHeaders[key].title}
                            {labelHeaders[key].required &&
                              <span role="presentation" aria-hidden="true"
                                    className="chakra-form__required-indicator css-1tfjd1n">*</span>}
                        </div>
                        <div className="sm:col-span-2">
                            <Select
                                required={labelHeaders[key].required}
                                onChange={(e) => {
                                    setMappedRecords(prevState => ({
                                        mappedHeaders: {
                                            ...prevState?.mappedHeaders,
                                            [key]: e.target.value
                                        }
                                    }))
                                }}
                                placeholder="Select option">
                                {records.fileHeaders.map((key) =>
                                    <option value={key}>{key}</option>
                                )}
                            </Select></div>
                    </div>
                )}

            </div>
            <div className="flex justify-end">
                <Button onClick={onMapClick}>Import</Button>
            </div>
        </FormControl>


    return <div>
        <FileUpload
            register={register}
            errors={errors}
            accept=".csv"
            field="file"
            label="Upload A Label Set"
            onFinish={onFileUpload}
        />
    </div>
}